import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { DomainService } from '@edtech-ui/core/services/admin-panel/domain.service';

@Component({
  selector: 'app-domain-enrollment',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
  ],
  templateUrl: './domain-enrollment.component.html',
  styleUrl: './domain-enrollment.component.scss'
})
export class DomainEnrollmentComponent implements OnInit {
  institutionName = '';
  primaryDomain = '';
  allowedDomains: string[] = [];
  newDomain = '';
  adminEmail = 'admin.sit.ac.in';

  autoEnrollment = true;
  emailVerificationRequired = true;
  batches: string[] = ['Batch A', 'Batch B', 'Batch C'];
  defaultBatch = '';

  constructor(private domainService: DomainService) { }

  ngOnInit(): void {
    this.domainService.getDomainSettings().subscribe((data) => {
      this.institutionName = data.institutionName;
      this.primaryDomain = data.primaryDomain;
      this.allowedDomains = data.allowedDomains;
      this.autoEnrollment = data.autoEnrollment;
      this.emailVerificationRequired = data.emailVerificationRequired;
      this.defaultBatch = data.defaultBatch;
    });
  }

  addDomain() {
    if (this.newDomain.trim()) {
      this.allowedDomains.push(this.newDomain.trim());
      this.newDomain = '';
    }
  }

  removeDomain(index: number) {
    this.allowedDomains.splice(index, 1);
  }

  saveSettings() {
    const payload = {
      allowedDomains: this.allowedDomains,
      autoEnrollment: this.autoEnrollment,
      emailVerificationRequired: this.emailVerificationRequired,
      defaultBatch: this.defaultBatch,
    };
    this.domainService.updateDomainSettings(payload).subscribe();
  }
}
